module.exports = __webpack_public_path__ + "ab42010d1b4462a6624ac103eae31de1.svg";